import React, { useState, useEffect } from 'react';
import './Profile.css';
import { defaultAvatarBase64 } from '../assets/default-avatar';

const Profile = () => {
  const [profileData, setProfileData] = useState(null);
  const [currentSociety, setCurrentSociety] = useState(null);
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    const loadProfileAndPermissions = () => {
      // Load profile data
      const profileDataStr = localStorage.getItem('profileData');
      const societyId = localStorage.getItem('societyId');
      const societiesData = localStorage.getItem('societies');

      if (profileDataStr && societyId && societiesData) {
        try {
          const profile = JSON.parse(profileDataStr);
          const societies = JSON.parse(societiesData);
          const society = societies.find(org => org.OrgId === societyId);
          
          setProfileData(profile);
          setCurrentSociety(society);
          setPermissions(society?.Permissions || []);
        } catch (error) {
          console.error('Error parsing profile data:', error);
        }
      }
    };

    loadProfileAndPermissions();

    // Listen for society changes
    window.addEventListener('storage', loadProfileAndPermissions);

    return () => {
      window.removeEventListener('storage', loadProfileAndPermissions);
    };
  }, []);

  if (!profileData) {
    return <div className="loading">Loading profile...</div>;
  }

  const formatPermissionName = (permission) => {
    // Check if permission is an object
    if (typeof permission === 'object' && permission !== null) {
      return permission.Name || permission.name || 'Unknown Permission';
    }
    
    // If it's a string, format it
    if (typeof permission === 'string') {
      return permission
        .split(':')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    }

    // Fallback
    return 'Unknown Permission';
  };

  return (
    <div className="profile-container">
      <div className="profile-card">
        <div className="profile-header">
          <div className="profile-avatar">
            <img 
              src={profileData.avatar || defaultAvatarBase64} 
              alt={profileData.name || 'User'} 
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = defaultAvatarBase64;
              }}
            />
          </div>
          <h1 className="profile-name">{profileData.name || 'User'}</h1>
          <p className="profile-email">{profileData.email}</p>
        </div>

        <div className="profile-details">
          {currentSociety && (
            <>
              <div className="detail-item">
                <label>Current Organization</label>
                <span>{currentSociety.Name}</span>
              </div>
              
              {permissions.length > 0 && (
                <div className="detail-item permissions-list">
                  <label>Permissions</label>
                  <div className="permissions-container">
                    {permissions.map((permission, index) => (
                      <span key={index} className="permission-badge">
                        {formatPermissionName(permission)}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Profile; 